import script from "./OrangeEasterEgg.vue?vue&type=script&setup=true&lang=js"
export * from "./OrangeEasterEgg.vue?vue&type=script&setup=true&lang=js"

import "./OrangeEasterEgg.vue?vue&type=style&index=0&id=4d6924c2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d6924c2"]])

export default __exports__